import { render, staticRenderFns } from "./TrainingResidences.vue?vue&type=template&id=4930d683&scoped=true&"
import script from "./TrainingResidences.vue?vue&type=script&lang=js&"
export * from "./TrainingResidences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930d683",
  null
  
)

export default component.exports